import { Fragment } from 'react';
import { useFirestoreGeneral } from '../../firebase/useFirestore'

const EventFieldMeta = ({fieldId}) => {

    const eventField = useFirestoreGeneral('EventFields', 'ID', fieldId || "");

  return (
    <>
        {eventField && eventField.map(field => (
             <Fragment key={field.ID}>
                {field.Title}
            </Fragment>
        ))}
    </>
  )
}

export default EventFieldMeta